import React, { useEffect, useState } from "react";
import LayoutHOC from "./LayoutHOC"; // Adjust the path if needed
import SelectComponent from "./UniversalComponents/SelectComponent";
import { color } from "framer-motion";
import LabelComponent from "./UniversalComponents/LabelComponent";
import ToggleSwitch from "./UniversalComponents/ToggleSwitch";
import { optionData } from "./Vendor/formConfig";
import { mySpaceFieldOptions, mySpaceFieldOptionsAddUpdate } from "../utils/api/mySpaceApi";
import { pushAlert } from "../utils/alertSlice";
import { useDispatch } from "react-redux";
import { getFormatedDate, getUserDate } from "../utils/utilityFunctions/stringUtility";
import { getDateFormat, getDateTimeFormat } from "../utils/utilityFunctions/localServices";
import { getUserDateTime } from "../utils/utilityFunctions/UTCFormat";

const OptionDataColered = [
  { value: "test", label: "test", color_code: "#1D4ED8" }, // blue-700
  { value: "test1", label: "test1", color_code: "#33ffdd" }, // gray-500
  { value: "test2", label: "test2 test2 test2 test2 test2 test2 test2", color_code: "#310082" }, // gray-100
  { value: "test3", label: "test3", color_code: "#0E8BFE" }, // gray-50
  { value: "test4", label: "test4", color_code: "#BE1176" }, // white
  { value: "test5", label: "test5", color_code: "#000000" }, // black
  { value: "test6", label: "test6", color_code: "#DC2626" }, // red-600
];

// "#310082",
//     "#962729",
//     "#0E8BFE",
//     "#BE1176",
//     "#73471B",

const OptionData = [
  { value: "test", label: "test" }, // blue-700
  { value: "test1", label: "test1" }, // gray-500
  { value: "test2", label: "test2" }, // gray-100
  { value: "test3", label: "test3" }, // gray-50
  { value: "test4", label: "test4" }, // white
  { value: "test5", label: "test5" }, // black
  { value: "test6", label: "test6" }, // red-600
];

const personList = [
  { value: 1, label: "John Doe", subLabel: "john.doe@example.com", isDeleteable: true },
  { value: 2, label: "Jane Smith", subLabel: "jane.smithasasaasaas@example.com" },
  { value: 3, label: "Michael Scott", subLabel: "michael.scott@example.com" },
  { value: 4, label: "Pam Beesly", subLabel: "pam.beesly@example.com" },
  { value: 5, label: "Jim Halpert", subLabel: "jim.halpert@example.com" },
  { value: 6, label: "Dwight Schrute", subLabel: "dwight.schrute@example.com" },
  { value: 7, label: "Angela Martin", subLabel: "angela.martin@example.com" },
];

const personListToggle = [
  { value: 1, label: "John Doe", subLabel: "john.doe@example.com", toggleType: "Internal User" },
  { value: 2, label: "Jane Smith", subLabel: "jane.smith@example.com", toggleType: "Internal User" },
  { value: 3, label: "Michael Scott", subLabel: "michael.scott@example.com", toggleType: "Internal User" },
  { value: 4, label: "Pam Beesly", subLabel: "pam.beesly@example.com", toggleType: "Internal User" },
  { value: 5, label: "Jim Halpert", subLabel: "jim.halpert@example.com", toggleType: "Internal User" },
  { value: 6, label: "Dwight Schrute", subLabel: "dwight.schrute@example.com", toggleType: "Internal User" },
  { value: 7, label: "Angela Martin", subLabel: "angela.martin@example.com", toggleType: "Internal User" },
  { value: 8, label: "Stanley Hudson", subLabel: "stanley.hudson@example.com", toggleType: "Internal User" },
  { value: 9, label: "Kevin Malone", subLabel: "kevin.malone@example.com", toggleType: "Internal User" },
  { value: 10, label: "Oscar Martinez", subLabel: "oscar.martinez@example.com", toggleType: "Internal User" },
  { value: 11, label: "Toby Flenderson", subLabel: "toby.flenderson@example.com", toggleType: "External User" },
  { value: 12, label: "Kelly Kapoor", subLabel: "kelly.kapoor@example.com", toggleType: "External User" },
  { value: 13, label: "Ryan Howard", subLabel: "ryan.howard@example.com", toggleType: "External User" },
  { value: 14, label: "Meredith Palmer", subLabel: "meredith.palmer@example.com", toggleType: "External User" },
  { value: 15, label: "Phyllis Vance", subLabel: "phyllis.vance@example.com", toggleType: "External User" },
  { value: 16, label: "Creed Bratton", subLabel: "creed.bratton@example.com", toggleType: "External User" },
  { value: 17, label: "Darryl Philbin", subLabel: "darryl.philbin@example.com", toggleType: "External User" },
  { value: 18, label: "Erin Hannon", subLabel: "erin.hannon@example.com", toggleType: "External User" },
  { value: 19, label: "Jan Levinson", subLabel: "jan.levinson@example.com", toggleType: "External User" },
  { value: 20, label: "Gabe Lewis", subLabel: "gabe.lewis@example.com", toggleType: "External User" },
];

const dateTypes = [
  { label: "DD/MM/YYYY", value: "DD/MM/YYYY", subLabel: "31/12/2025" }, // 31/12/2025
  { label: "MM/DD/YYYY", value: "MM/DD/YYYY", subLabel: "12/31/2025" }, // 12/31/2025
  { label: "YYYY/MM/DD", value: "YYYY/MM/DD", subLabel: "2025/12/31" }, // 2025/12/31
  { label: "YYYY-DD-MM", value: "YYYY-DD-MM", subLabel: "2025-31-12" }, // 2025-31-12
  { label: "DD-MM-YYYY", value: "DD-MM-YYYY", subLabel: "31-12-2025" }, // 31-12-2025
  { label: "MM-DD-YYYY", value: "MM-DD-YYYY", subLabel: "12-31-2025" }, // 12-31-2025
  { label: "YYYY.MM.DD", value: "YYYY.MM.DD", subLabel: "2025.12.31" }, // 2025.12.31
  { label: "DD.MM.YYYY", value: "DD.MM.YYYY", subLabel: "31.12.2025" }, // 31.12.2025
  { label: "MMM D, YYYY", value: "MMM D, YYYY", subLabel: "Dec 31, 2025" }, // Dec 31, 2025
  { label: "MMMM D, YYYY", value: "MMMM D, YYYY", subLabel: "December 31, 2025" }, // December 31, 2025
  { label: "D MMM YYYY", value: "D MMM YYYY", subLabel: "31 Dec 2025" }, // 31 Dec 2025
  { label: "YYYY-MMM-DD", value: "YYYY-MMM-DD", subLabel: "2025-Dec-31" }, // 2025-Dec-31
];

const dateTimeTypes = [
  {
    label: "DD/MM/YYYY HH:mm",
    value: { dateFormate: "DD/MM/YYYY", timeFormate: "HH:mm" },
  },
  {
    label: "MM/DD/YYYY - hh:mm A",
    value: { dateFormate: "MM/DD/YYYY", timeFormate: "hh:mm A" },
  },
  {
    label: "YYYY-MM-DD HH:mm",
    value: { dateFormate: "YYYY-MM-DD", timeFormate: "HH:mm" },
  },
  {
    label: "Do MMMM YYYY hh:mm A",
    value: { dateFormate: "Do MMMM YYYY", timeFormate: "hh:mm A" },
  },
  // 🕒 Time-only (for time pickers)
  { label: "hh:mm A", value: { dateFormate: "", timeFormate: "hh:mm A" } },
  { label: "HH:mm", value: { dateFormate: "", timeFormate: "HH:mm" } },

  // 📅 Date-only (for date pickers)
  { label: "DD/MM/YYYY", value: { dateFormate: "DD/MM/YYYY", timeFormate: "" } }, // 06/10/2025
  { label: "MM/DD/YYYY", value: { dateFormate: "MM/DD/YYYY", timeFormate: "" } }, // 10/06/2025
  { label: "YYYY-MM-DD", value: { dateFormate: "YYYY-MM-DD", timeFormate: "" } }, // 2025-10-06
  { label: "DD MMM YYYY", value: { dateFormate: "DD MMM YYYY", timeFormate: "" } }, // 06 Oct 2025
  { label: "Do MMM YYYY", value: { dateFormate: "Do MMM YYYY", timeFormate: "" } }, // 6th Oct 2025
  { label: "Do MMMM YYYY", value: { dateFormate: "Do MMMM YYYY", timeFormate: "" } }, // 6th October 2025
  { label: "YYYY-MMM-DD", value: { dateFormate: "YYYY-MMM-DD", timeFormate: "" } }, // 2025-Oct-06
  { label: "dddd, MMMM Do YYYY", value: { dateFormate: "dddd, MMMM Do YYYY", timeFormate: "" } }, // Monday, October 6th 2025
  { label: "DD.MM.YYYY", value: { dateFormate: "DD.MM.YYYY", timeFormate: "" } }, // 06.10.2025
  { label: "DD-MM-YYYY", value: { dateFormate: "DD-MM-YYYY", timeFormate: "" } }, // 06-10-2025
  { label: "D MMMM YYYY HH:mm", value: { dateFormate: "D MMMM YYYY", timeFormate: "HH:mm" } }, // 06 October 2025 14:30
  { label: "DD MMM YYYY HH:mm", value: { dateFormate: "DD MMM YYYY", timeFormate: "HH:mm" } }, // 06 Oct 2025 14:30
];

const MockPage = () => {
  const [isSmallSize, setIsSmallSize] = useState(true);

  const [crudData, setCrudData] = useState([]);
  const [crudDataColored, setCrudDataColored] = useState([]);
  const [selectedFormat, setSelectedFormat] = useState(getDateFormat());

  const dispatch = useDispatch();

  const [selectedDateTimeFormat, setSelectedDateTimeFormat] = useState(getDateTimeFormat());

  const handleChange = (e) => {
    const newFormat = e.target.value[0] || "DD/MM/YYYY";
    setSelectedFormat(newFormat);
    localStorage.setItem("date_formate", JSON.stringify({ dateFormate: newFormat }));
    console.log(newFormat, "sdfdsad");
  };

  useEffect(() => {
    const savedFormat = getDateTimeFormat();
    console.log("Initial format from localStorage:", savedFormat);
    setSelectedDateTimeFormat(savedFormat);
  }, []);

  const handleDateTimeChange = (selectedOptions) => {
    // Extract the selected format
    const newFormat = selectedOptions?.length > 0 ? selectedOptions[0].value : getDateTimeFormat();

    setSelectedDateTimeFormat(newFormat);
    localStorage.setItem("date_time_formate", JSON.stringify(newFormat));
    console.log("Date/time format saved:", newFormat);
  };

  // matching option for SelectComponent
  const matchedOption = dateTimeTypes.find(
    (dt) =>
      dt.value.dateFormate === selectedDateTimeFormat?.dateFormate &&
      dt.value.timeFormate === selectedDateTimeFormat?.timeFormate
  );

  console.log("Current selectedDateTimeFormat:", selectedDateTimeFormat);
  console.log("Matched option:", matchedOption);

  const sampleDate = "2025-10-02";
  const sampleDatetime = "14:30";
  // console.log(getUserDate("2025-10-02"));

  const fetchCrudData = async () => {
    const response = await mySpaceFieldOptions({ params: { fieldId: "3fa583b-806e-472b-972d-6fdb58584873" } });

    if (response?.success) {
      if (response?.data?.length > 0) {
        const formatedResponse = response?.data?.map((data) => {
          return {
            value: data?.id,
            label: data?.option_value?.value,

            // color_code: data?.option_value?.color_code,
          };
        });
        setCrudData(formatedResponse);
      } else {
        setCrudData([]);
      }
    } else {
      dispatch(
        pushAlert({
          visible: true,
          message: response?.data?.message,
          type: "danger",
        })
      );
    }
  };

  const fetchCrudDataColored = async () => {
    const response = await mySpaceFieldOptions({ params: { fieldId: "a8a0c443-8d70-4ca2-8380-2fa8b8fb81f1" } });

    if (response?.success) {
      if (response?.data?.length > 0) {
        const formatedResponse = response?.data?.map((data) => {
          return {
            value: data?.id,
            label: data?.option_value?.value,

            color_code: data?.option_value?.color_code,
          };
        });
        setCrudDataColored(formatedResponse);
      } else {
        setCrudDataColored([]);
      }
    } else {
      dispatch(
        pushAlert({
          visible: true,
          message: response?.data?.message,
          type: "danger",
        })
      );
    }
  };

  useEffect(() => {
    fetchCrudData();
    fetchCrudDataColored();
  }, []);

  const handleFieldOptionAdd = async (optionData, OldOtion) => {
    try {
      let body = {
        option: {
          value: optionData.value,
        },
        ...(OldOtion?.value && { optionId: OldOtion.value }),
      };

      if (optionData?.color_code) {
        body = {
          option: {
            value: optionData.value,
            color_code: optionData.color_code,
          },
          ...(OldOtion?.value && { optionId: OldOtion.value }),
        };
      }

      const response = await mySpaceFieldOptionsAddUpdate({
        body,
        params: { fieldId: "c9d64b3d-90bd-4bce-b32d-e37caff40df8" },
      });

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "success",
          })
        );
        fetchCrudData();
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleFieldOptionAddColored = async (optionData, OldOtion) => {
    try {
      let body = {
        option: {
          value: optionData.value,
        },
        ...(OldOtion?.value && { optionId: OldOtion.value }),
      };

      if (optionData?.color_code) {
        body = {
          option: {
            value: optionData.value,
            color_code: optionData.color_code,
          },
          ...(OldOtion?.value && { optionId: OldOtion.value }),
        };
      }

      const response = await mySpaceFieldOptionsAddUpdate({
        body,
        params: { fieldId: "a8a0c443-8d70-4ca2-8380-2fa8b8fb81f1" },
      });

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "success",
          })
        );
        fetchCrudDataColored();
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  return (
    <div className="p-6 flex flex-col gap-10">
      <div className="">
        <h1 className="text-2xl font-bold mb-4">Mock Page</h1>
        <p className="text-gray-700">
          This is a mock page used for layout testing, design validation, or placeholder content while the actual
          feature is under development.
        </p>

        <LabelComponent labelText="Size :" size="medium" />
        <ToggleSwitch
          leftEle={"Small"}
          rightEle={"Medium"}
          // toggleState={selectedOptions[0]?.toggleType ? "Small" === selectedOptions[0].toggleType : true}
          onToggle={(isToggled) => setIsSmallSize(isToggled)}
          // className={"w-[155px] "}
        />
      </div>

      <div className="flex gap-4 mt-10">
        <div className="w-full">
          <LabelComponent labelText="Single Select with Color" size={isSmallSize ? "small" : "medium"} />
          <SelectComponent
            onChange={() => {}}
            options={OptionDataColered}
            placeholder="Select an Option"
            showSearch
            size={isSmallSize ? "small" : "medium"}
          />
        </div>

        <div className="w-full">
          <LabelComponent labelText="Multi Select with Color" size={isSmallSize ? "small" : "medium"} />
          <SelectComponent
            onChange={() => {}}
            options={OptionDataColered}
            placeholder="Select an Option"
            showSearch
            multiSelect
            size={isSmallSize ? "small" : "medium"}
          />
        </div>

        <div className="w-full">
          <LabelComponent labelText="Person single Select" size={isSmallSize ? "small" : "medium"} />
          <SelectComponent
            onChange={() => {}}
            options={personList}
            personList
            placeholder="Select an Option"
            showSearch
            boxWidth
            size={isSmallSize ? "small" : "medium"}
          />
        </div>
      </div>

      <div className="flex gap-4 mt-10">
        <div className="w-full">
          <LabelComponent labelText="Single Select" size={isSmallSize ? "small" : "medium"} />
          <SelectComponent
            onChange={() => {}}
            options={OptionData}
            placeholder="Select an Option"
            showSearch
            size={isSmallSize ? "small" : "medium"}
          />
        </div>

        <div className="w-full">
          <LabelComponent labelText="Select Date Formate" size={isSmallSize ? "small" : "medium"} />
          <SelectComponent
            onChange={handleChange}
            options={dateTypes}
            value={[dateTypes.find((dt) => dt.value === selectedFormat)]}
            //  value={selectedFormat ? [dateTypes.find((dt) => dt.value === selectedFormat)] : []}
            placeholder="Select an Option"
            showSearch
            size={isSmallSize ? "small" : "medium"}
          />
          <p className="mt-4 text-base flex flex-col">
            <span className="font-semibold">
              Sample Date :<span className="text-blue-500">{sampleDate}</span>
            </span>
            <span className="font-semibold">
              {" "}
              Formatted Date :<span className="text-blue-500"> {getUserDate(sampleDate)}</span>
            </span>
          </p>
        </div>

        <div className="w-full">
          <LabelComponent labelText="Select Date & Time Format" size={isSmallSize ? "small" : "medium"} />
          <SelectComponent
            options={dateTimeTypes}
            onChange={handleDateTimeChange}
            value={matchedOption ? [matchedOption] : []}
            placeholder="Select an Option"
            showSearch
            size={isSmallSize ? "small" : "medium"}
            noFormInput={true} // Pass selected options directly
          />
          <p className="mt-4 text-base flex flex-col">
            <span className="font-semibold">
              Sample Date:<span className="text-blue-600"> {sampleDatetime}</span>
            </span>
            <span className="font-semibold">
              Formatted Date & Time: <span className="text-blue-600"> {getUserDateTime(sampleDatetime)}</span>
            </span>
          </p>
        </div>
        <div className="w-full">
          <LabelComponent labelText="Multi Select" size={isSmallSize ? "small" : "medium"} />
          <SelectComponent
            onChange={() => {}}
            options={OptionData}
            placeholder="Select an Option"
            showSearch
            multiSelect
            size={isSmallSize ? "small" : "medium"}
          />
        </div>

        <div className="w-full">
          <LabelComponent labelText="person MutliSelect" size={isSmallSize ? "small" : "medium"} />
          <SelectComponent
            onChange={() => {}}
            options={personList}
            placeholder="Select an Option"
            personList
            multiSelect
            showSearch
            size={isSmallSize ? "small" : "medium"}
          />
        </div>
      </div>

      <div className="flex gap-4 mt-10">
        <div className="w-full">
          <LabelComponent labelText="Single Select Tag" size={isSmallSize ? "small" : "medium"} />
          <SelectComponent
            onChange={() => {}}
            options={OptionDataColered}
            placeholder="Select an Option"
            showSearch
            isTagList
            size={isSmallSize ? "small" : "medium"}
          />
        </div>

        <div className="w-full">
          <LabelComponent labelText="Multi Select Tag" size={isSmallSize ? "small" : "medium"} />
          <SelectComponent
            onChange={() => {}}
            options={OptionDataColered}
            placeholder="Select an Option"
            showSearch
            multiSelect
            isTagList
            size={isSmallSize ? "small" : "medium"}
          />
        </div>

        <div className="w-full">
          <LabelComponent labelText="Single Select with Null Selector" size={isSmallSize ? "small" : "medium"} />
          <SelectComponent
            onChange={() => {}}
            options={OptionData}
            placeholder="Select an Option"
            showSearch
            nullSelector
            size={isSmallSize ? "small" : "medium"}
          />
        </div>
      </div>

      <div className="flex gap-4 mt-10">
        <div className="w-full">
          <LabelComponent labelText="Internal Crud on Select" size={isSmallSize ? "small" : "medium"} />
          <SelectComponent
            onChange={() => {}}
            options={crudData}
            placeholder="Select an Option"
            showSearch
            isEditList
            inlineCrud
            addButton
            addButtonAction={(val) => handleFieldOptionAdd(val)}
            editListHandler={(val, val2) => handleFieldOptionAdd(val2, val)}
            size={isSmallSize ? "small" : "medium"}
          />
        </div>

        <div className="w-full">
          <LabelComponent labelText="Internal Crud on Select Colored" size={isSmallSize ? "small" : "medium"} />
          <SelectComponent
            onChange={() => {}}
            options={crudDataColored}
            placeholder="Select an Option"
            showSearch
            isEditList
            inlineCrud
            size={isSmallSize ? "small" : "medium"}
            addButton
            addButtonAction={(val) => handleFieldOptionAddColored(val)}
            editListHandler={(val, val2) => handleFieldOptionAddColored(val2, val)}
          />
        </div>

        <div className="w-full">
          <LabelComponent labelText="Select with Toggle BUtton" size={isSmallSize ? "small" : "medium"} />
          <SelectComponent
            onChange={() => {}}
            options={personListToggle}
            placeholder="Select an Option"
            showSearch
            toggleButtons={["Internal User", "External User"]}
            size={isSmallSize ? "small" : "medium"}
          />
        </div>
      </div>

      {/* <div className="flex gap-4 mt-10">
        <div className="w-full">
          <LabelComponent labelText="Single Select with Color small" size={isSmallSize ? "small" : "medium"} />
          <SelectComponent onChange={() => {}} options={OptionDataColered} placeholder="Select an Option" showSearch size={isSmallSize ? "small" : "medium"}  />
        </div>

        <div className="w-full">
          <LabelComponent labelText="Multi Select with Color small" size={isSmallSize ? "small" : "medium"} />
          <SelectComponent
            onChange={() => {}}
            options={OptionDataColered}
            placeholder="Select an Option"
            showSearch
            multiSelect
            size={isSmallSize ? "small" : "medium"} 
          />
        </div>

        <div className="w-full">
          <LabelComponent labelText="Person single Select small" size={isSmallSize ? "small" : "medium"} />
          <SelectComponent
            onChange={() => {}}
            options={personList}
            personList
            placeholder="Select an Option"
            showSearch
            size={isSmallSize ? "small" : "medium"} 
          />
        </div>
      </div> */}

      <br />
      <br />
      <br />

      <select
        onChange={(e) => {
          console.log(e.target);
        }}
      >
        <option value="volvo">Volvo</option>
        <option value="saab">Saab</option>
        <option value="opel">Opel</option>
        <option value="audi">Audi</option>
      </select>
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};

export default LayoutHOC(MockPage);
